<template v-if="isAuth"><side-menu></side-menu><div class="content"><router-view></router-view></div></template><app-modal></app-modal>